import Images from './component';

export default Images;
